import React, { useState, useEffect } from "react";
import {
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    FormControl,
    FormLabel,
    Input,
    Select,
    HStack,
    RadioGroup,
    Radio,
    Switch,
    VStack,
    IconButton,
    CheckboxGroup,
    Checkbox,
    useToast,
    Text,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
} from "@chakra-ui/react";
import { AddIcon, CloseIcon } from "@chakra-ui/icons";
import axios from "axios";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const FeesMasterModal = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [feeGroup, setFeeGroup] = useState("");
    const [feeGroups, setFeeGroups] = useState([]);
    const [classId, setClassId] = useState("");
    const [startDate, setStartDate] = useState("");
    const [dueDate, setDueDate] = useState("");
    const [fineType, setFineType] = useState("None");
    const [intervals, setIntervals] = useState([{ days: "", fineAmount: "" }]);
    const [selectedFeeTypes, setSelectedFeeTypes] = useState([]);
    const [feeTypes, setFeeTypes] = useState([]);
    const [amounts, setAmounts] = useState({});
    const [status, setStatus] = useState(true);
    const [selectedTerms, setSelectedTerms] = useState([]); // Track selected terms
    const toast = useToast();
    const [classes, setClasses] = useState([]);
    const [selectedClass, setSelectedClass] = useState('');
    const [feeStructures, setFeeStructures] = useState([]); // Stores API data
    const [feeStructure, setFeeStructure] = useState(""); // Stores selected value
    const [selectedFeeTypesByTerm, setSelectedFeeTypesByTerm] = useState(""); // Stores selected value
    const [feeGroupsByTerm, setFeeGroupsByTerm] = useState({}); // Fee group per term
    const [amountsByTerm, setAmountsByTerm] = useState({}); // Amounts per term
    const [feeTypesByTerm, setFeeTypesByTerm] = useState({}); // Fee types per term
    const [termDates, setTermDates] = useState({});
    const openModal = () => setIsOpen(true);
    const closeModal = () => {
        setIsOpen(false);
        resetForm();
    };

    const resetForm = () => {
        setFeeGroup("");
        setClassId("");
        setStartDate("");
        setDueDate("");
        setFineType("None");
        setIntervals([{ days: "", fineAmount: "" }]);
        setSelectedFeeTypes([]);
        setAmounts({});
        setStatus(true);
    };

    const handleFeeGroupChange = (term, feeGroup) => {
        console.log("Before update:", feeGroupsByTerm);  // Log current fee group states for all terms
        console.log("Selected Fee Group for Term", term, ":", feeGroup);

        // Set fee group for the selected term
        setFeeGroupsByTerm((prev) => ({
            ...prev,
            [term]: feeGroup,
        }));

        // Reset fee types for the selected term whenever the fee group is changed
        setSelectedFeeTypesByTerm((prev) => ({
            ...prev,
            [term]: [],  // Reset fee types for the selected term to prevent carryover
        }));

        console.log("Fee Groups after update:", feeGroupsByTerm);
    };




    useEffect(() => {
        // Load Fee Groups
        const fetchFeeGroups = async () => {
            try {
                const response = await axios.post(`${BASE_URL}/admin/Fees/fees_master/load_group.php`, {
                    org_id: sessionStorage.getItem('cmp_id'), // Replace with actual org_id
                });
                if (response.data.success) {
                    setFeeGroups(response.data.data);
                } else {
                    toast({
                        title: "Error",
                        description: response.data.message || "Failed to load fee groups.",
                        status: "error",
                        duration: 5000,
                        isClosable: true,
                    });
                }
            } catch (error) {
                toast({
                    title: "Error",
                    description: error.message || "Failed to load fee groups.",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
            }
        };

        // Load Fee Types when Fee Group changes
        const fetchFeeTypes = async (feeGroupId) => {
            console.log('Selected Fee Group ID:', feeGroupId);  // Log selected Fee Group ID
            try {
                const response = await axios.post(
                    `${BASE_URL}/admin/Fees/fees_master/load_types.php`,
                    { fee_group_id: feeGroupId }
                );
                if (response.data.success) {
                    setFeeTypes(response.data.data);
                } else {
                    setFeeTypes([]); // Clear types if no data found
                    toast({
                        title: "Error",
                        description: response.data.message || "Failed to load fee types.",
                        status: "error",
                        duration: 5000,
                        isClosable: true,
                    });
                }
            } catch (error) {
                setFeeTypes([]);
                toast({
                    title: "Error",
                    description: error.message || "Failed to load fee types.",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
            }
        };

        // Trigger fetch for fee types of all selected terms
        selectedTerms.forEach((term) => {
            const feeGroup = feeGroupsByTerm[term]; // Get the selected fee group for this term
            if (feeGroup) {
                fetchFeeTypes(feeGroup);
            }
        });

        // Load Fee Groups when component mounts
        fetchFeeGroups();
    }, [feeGroupsByTerm, selectedTerms, toast]); // Dependency array includes feeGroupsByTerm and selectedTerms



    useEffect(() => {
        // Fetch fee structure data from the API
        const fetchFeeStructures = async () => {
            try {
                const response = await fetch(
                    `${BASE_URL}/admin/Fees/fees_master/load_fee_structure.php`
                );
                const data = await response.json();
                console.log('====================================');
                console.log("sdsdsd", data);
                console.log('====================================');
                setFeeStructures(data.data); // Assuming the API returns an array of objects
            } catch (error) {
                console.error("Error fetching fee structures:", error);
            }
        };

        fetchFeeStructures();
    }, []);

    const handleTermSelection = (value) => {
        setSelectedTerms(value);
    };

    const handleIntervalChange = (index, field, value) => {
        const updatedIntervals = [...intervals];
        updatedIntervals[index][field] = value;
        setIntervals(updatedIntervals);
    };

    const addInterval = () => {
        setIntervals([...intervals, { days: "", fineAmount: "" }]);
    };

    const removeInterval = (index) => {
        const updatedIntervals = intervals.filter((_, i) => i !== index);
        setIntervals(updatedIntervals);
    };


    // In your handleFeeTypeChange function, make sure you're updating the fee types per term:
    const handleFeeTypeChange = (term, selectedFeeTypes) => {
        setSelectedFeeTypesByTerm((prev) => ({
            ...prev,
            [term]: selectedFeeTypes,  // Store selected fee types independently for each term
        }));
        console.log(`Fee Types updated for Term ${term}:`, selectedFeeTypes);
    };




    // Similarly for amounts, make sure the state is managed per term:
    const handleAmountChange = (term, feeTypeId, value) => {
        setAmounts((prev) => ({
            ...prev,
            [term]: {
                ...prev[term],
                [feeTypeId]: value, // Store amount per term and feeTypeId
            },
        }));
    };



    const handleFeeTypeSelection = (term, selectedFeeTypes) => {
        setFeeTypesByTerm((prev) => ({
            ...prev,
            [term]: selectedFeeTypes,
        }));
    };

    const handleTermDateChange = (term, dateType, value) => {
        setTermDates((prevDates) => ({
            ...prevDates,
            [term]: {
                ...prevDates[term],
                [dateType]: value,
            },
        }));
    };

    // Normalize and ensure unique selectedFeeTypes
    const normalizedFeeTypes = [...new Set(selectedFeeTypes.map(feeTypeId => String(feeTypeId)))];

    // Update `calculateTotalAmount` function to use normalized fee types
    // Function to calculate the total amount for a specific term
    const calculateTotalAmount = (term) => {
        const selectedFeeTypes = selectedFeeTypesByTerm[term] || [];
        return selectedFeeTypes.reduce((total, feeTypeId) => {
            const feeAmount = amounts[term]?.[feeTypeId] || 0;
            return total + (parseFloat(feeAmount) || 0);
        }, 0);
    };


    useEffect(() => {
        // Fetch classes
        fetch(`${BASE_URL}/admin/class/class_master.php`)
            .then(response => response.json())
            .then(data => Array.isArray(data.data) && setClasses(data.data))
            .catch(error => console.error('Error fetching classes:', error));

    }, []);


    const preparePayload = () => {
        console.log('Preparing payload...');

        const fineIntervals = intervals.map((interval) => {
            const intervalDays = parseInt(interval.days) || 0;
            const fineAmountOrPercentage = fineType === 'Percentage' ? 'fine_percentage' : 'fine_amount';
            const fineValue = fineType === 'Percentage' ? parseFloat(interval.fineAmount) || 0 : parseFloat(interval.fineAmount) || 0;

            console.log(`Interval: Days = ${intervalDays}, Fine Value (${fineAmountOrPercentage}): ${fineValue}`);  // Log interval data

            return {
                intervals: intervalDays,
                [fineAmountOrPercentage]: fineValue,
                fixed: interval.fixed || null,  // Assuming `fixed` field exists in your modal data
            };
        });

        const payload = {
            fee_structure_id: 3,
            class_id: selectedClass ? parseInt(selectedClass) : 1,  // Ensure this is selected and valid
            fine_type: fineType.toLowerCase(),
            org_id: sessionStorage.getItem('cmp_id'),  // Replace with actual org_id if needed
            user_id: sessionStorage.getItem('user_id'),
            fine_intervals: fineIntervals,  // Dynamic intervals
            terms: selectedTerms.map((term) => {
                const feeGroup = feeGroupsByTerm[term] || '';
                const feeAmount = (selectedFeeTypesByTerm[term] || []).map((feeTypeId) => ({
                    fee_type_id: parseInt(feeTypeId),
                    amount: parseFloat(amounts[term]?.[feeTypeId]) || 0,
                })).filter((fee) => fee.amount > 0); // Exclude empty or zero amounts
                return {
                    fee_name: `Term ${term} Fee`,  // Customize fee_name if needed
                    fee_group_id: feeGroup,
                    start_date: termDates[term]?.startDate || "",  // Get start date from modal input
                    due_date: termDates[term]?.endDate || "",  // Get due date from modal input
                    fee_amounts: feeAmount // Dynamic fee amounts based on modal data
                };
            }),
            status: status ? 1 : 0,
            // start_date: '2024-12-19',  // This can also be dynamically set if needed
            // due_date: '2025-02-08',  // Replace with actual logic for due date
        };

        // Log the entire payload before returning
        console.log('Prepared Payload:', payload);
        return payload;
    };





    const submitForm = async () => {
        const payload = preparePayload();
        console.log(payload);


        try {
            const response = await axios.post(
                `${BASE_URL}/admin/Fees/fees_master/fee_master.php`,
                payload,
                { headers: { "Content-Type": "application/json" } }
            );
            console.log(response);

            if (response.data.success) {
                toast({
                    title: "Success",
                    description: "Fees Master added successfully.",
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                });
                closeModal();
            } else {
                throw new Error(response.data.message || "Failed to add Fees Master.");
            }
        } catch (error) {
            toast({
                title: "Error",
                description: error.message || "Something went wrong.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        }
    };



    return (
        <>
            <Button colorScheme="teal" leftIcon={<AddIcon />} onClick={openModal}>
                Add Fees
            </Button>
            <Modal isOpen={isOpen} onClose={closeModal} size="lg">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        Add Fees Master
                        <Button
                            size="sm"
                            ml={3}
                            colorScheme="blue"
                            variant="outline"
                            fontSize="sm"
                        >
                            2024 - 2025
                        </Button>
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <FormControl mb={4} p={2}>
                            <FormLabel>Class</FormLabel>
                            <Select placeholder="Select class" onChange={(e) => {
                                const classId = e.target.value;
                                setSelectedClass(classId);
                                console.log("Selected Class ID:", classId);
                            }}>
                                {classes.map(cls => (
                                    <option key={cls.id} value={cls.id}>{cls.class}</option>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl mb={4}>
                            <FormLabel>Fees Structure</FormLabel>
                            <Select
                                placeholder="Select Fees Structure"
                                value={feeStructure}
                                onChange={(e) => {
                                    const selectedFee = e.target.value;
                                    setFeeStructure(selectedFee);
                                    console.log("Selected Fee Structure:", selectedFee);
                                }}
                            >
                                {feeStructures?.map((structure) => (
                                    <option key={structure.id} value={structure.id}>
                                        {structure.name}
                                    </option>
                                ))}
                            </Select>
                        </FormControl>
                        {feeStructure === "3" && (
                            <FormControl mb={4}>
                                <FormLabel>Select Terms</FormLabel>
                                <CheckboxGroup value={selectedTerms} onChange={handleTermSelection}>
                                    <HStack align="start">
                                        {[1, 2, 3, 4].map(term => (
                                            <Checkbox key={term} value={term.toString()}>Term {term}</Checkbox>
                                        ))}
                                    </HStack>
                                </CheckboxGroup>
                            </FormControl>
                        )}
                        {selectedTerms.length > 0 && (
                            <Accordion allowToggle>
                                {selectedTerms.map((term) => (
                                    <AccordionItem key={term}>
                                        <AccordionButton>
                                            <Text flex="1" textAlign="left">Term {term}</Text>
                                            <AccordionIcon />
                                        </AccordionButton>
                                        <AccordionPanel pb={4}>
                                            <FormControl mb={4}>
                                                <FormLabel>Fees Group</FormLabel>
                                                <Select
                                                    placeholder="Select Fees Group"
                                                    value={feeGroupsByTerm[term] || ""}
                                                    onChange={(e) => {
                                                        handleFeeGroupChange(term, e.target.value);
                                                        console.log(`Fee Group selected for Term ${term}:`, e.target.value);
                                                    }}
                                                >
                                                    {feeGroups.map((group) => (
                                                        <option key={group.id} value={group.id}>
                                                            {group.group_name}
                                                        </option>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                            <FormControl mb={4}>
                                                <FormLabel>Fees Type</FormLabel>
                                                <CheckboxGroup
                                                    colorScheme="blue"
                                                    value={selectedFeeTypesByTerm[term] || []}
                                                    onChange={(value) => {
                                                        handleFeeTypeChange(term, value);
                                                        console.log(`Fee Types selected for Term ${term}:`, value);
                                                    }}
                                                >
                                                    <VStack align="start" spacing={4}>
                                                        {feeTypes.map((feeType) => (
                                                            <Checkbox key={feeType.id} value={feeType.id.toString()}>
                                                                {feeType.type_name}
                                                            </Checkbox>
                                                        ))}
                                                    </VStack>
                                                </CheckboxGroup>
                                            </FormControl>
                                            <VStack spacing={4} align="start" mt={4}>
                                                {selectedFeeTypesByTerm[term]?.length > 0 ? (
                                                    selectedFeeTypesByTerm[term].map((feeTypeId) => {
                                                        const feeType = feeTypes.find(fee => fee.id === parseInt(feeTypeId));
                                                        return feeType ? (
                                                            <FormControl key={feeTypeId} mb={4}>
                                                                <FormLabel>{`Fee Type ${feeType.type_name} Amount`}</FormLabel>
                                                                <Input
                                                                    type="number"
                                                                    value={amounts[term]?.[feeTypeId] || ""}
                                                                    onChange={(e) => {
                                                                        handleAmountChange(term, feeTypeId, e.target.value);
                                                                        console.log(`Amount changed for Term ${term}, Fee Type ${feeTypeId}:`, e.target.value);
                                                                    }}
                                                                />
                                                            </FormControl>
                                                        ) : null;
                                                    })
                                                ) : (
                                                    <Text color="gray.500">No fee types selected.</Text>
                                                )}
                                            </VStack>
                                            <FormControl mb={4}>
                                                <FormLabel>Total Amount</FormLabel>
                                                <Input
                                                    type="number"
                                                    value={calculateTotalAmount(term)}
                                                    isReadOnly
                                                />
                                            </FormControl>


                                            <FormControl mb={4}>
                                                <FormLabel>Term Start Date</FormLabel>
                                                <Input
                                                    type="date"
                                                    value={termDates[term]?.startDate || ""}
                                                    onChange={(e) => handleTermDateChange(term, 'startDate', e.target.value)}
                                                />
                                            </FormControl>

                                            <FormControl mb={4}>
                                                <FormLabel>Term End Date</FormLabel>
                                                <Input
                                                    type="date"
                                                    value={termDates[term]?.endDate || ""}
                                                    onChange={(e) => handleTermDateChange(term, 'endDate', e.target.value)}
                                                />
                                            </FormControl>
                                        </AccordionPanel>
                                    </AccordionItem>
                                ))}
                            </Accordion>
                        )}


                        <FormControl mb={4}>
                            <FormLabel>Fine Type</FormLabel>
                            <RadioGroup
                                value={fineType}
                                onChange={(value) => {
                                    setFineType(value);
                                    console.log("Selected Fine Type:", value);
                                }}
                            >
                                <HStack spacing={4}>
                                    <Radio value="None">None</Radio>
                                    <Radio value="Percentage">Percentage</Radio>
                                    <Radio value="Amount">Amount</Radio>
                                </HStack>
                            </RadioGroup>
                        </FormControl>
                        {fineType !== "None" && (
                            <>
                                <FormControl mb={4}>
                                    <FormLabel>Interval Details</FormLabel>
                                    <VStack spacing={3}>
                                        {intervals.map((interval, index) => (
                                            <HStack key={index} spacing={4} align="center">
                                                <Input
                                                    placeholder="Days"
                                                    type="number"
                                                    value={interval.days}
                                                    onChange={(e) => {
                                                        handleIntervalChange(index, "days", e.target.value);
                                                        console.log(`Interval Days changed for index ${index}:`, e.target.value);
                                                    }}
                                                />
                                                <Input
                                                    placeholder="Fine "
                                                    type="number"
                                                    value={interval.fineAmount}
                                                    onChange={(e) => {
                                                        handleIntervalChange(index, "fineAmount", e.target.value);
                                                        console.log(`Interval Fine Amount changed for index ${index}:`, e.target.value);
                                                    }}
                                                />
                                                <IconButton
                                                    size="sm"
                                                    colorScheme="red"
                                                    icon={<CloseIcon />}
                                                    onClick={() => removeInterval(index)}
                                                    aria-label="Remove Interval"
                                                />
                                            </HStack>
                                        ))}
                                        <Button
                                            size="sm"
                                            colorScheme="blue"
                                            variant="outline"
                                            onClick={addInterval}
                                        >
                                            Add Interval
                                        </Button>
                                    </VStack>
                                </FormControl>
                            </>
                        )}
                        <FormControl display="flex" alignItems="center" mb={4}>
                            <FormLabel>Status</FormLabel>
                            <Switch
                                colorScheme="blue"
                                isChecked={status}
                                onChange={(e) => {
                                    setStatus(e.target.checked);
                                    console.log("Status changed:", e.target.checked);
                                }}
                            />
                        </FormControl>
                        <Text fontSize="sm" color="gray.500">
                            Toggle the status
                        </Text>
                    </ModalBody>

                    <ModalFooter>
                        <Button onClick={closeModal} mr={3}>
                            Cancel
                        </Button>
                        <Button colorScheme="blue" onClick={submitForm}>
                            Add Fees Master
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

        </>
    );
};

export default FeesMasterModal;
